import { getCookie, isEmpty } from "./browserHelpers";
import { getSearchParams } from "./generalUtils";

export const intToString = (num: number, toFixed = 1) => {
  num = num.toString().replace(/[^0-9.]/g, "");
  if (num < 1000) {
    return num;
  }
  const si = [
    { v: 1e3, s: "k" },
    { v: 1e5, s: "L" },
    { v: 1e6, s: "m" },
    { v: 1e9, s: "b" },
    { v: 1e12, s: "t" },
    { v: 1e15, s: "p" },
    { v: 1e18, s: "e" },
  ];
  let index;
  for (index = si.length - 1; index > 0; index--) {
    if (num >= si[index].v) {
      break;
    }
  }
  return (
    (num / si[index].v)
      .toFixed(toFixed)
      .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[index].s
  );
};

export const formatNumberInK = (num: number) => {
  if (num >= 1000) {
    return `${num / 1000}k`;
  } else return num;
};

export const setUTMCookie = (utmParams: Record<string, string>) => {
  if (!isEmpty(utmParams)) {
    const busUTM = JSON.stringify(utmParams);
    const now = new Date();
    let time = now.getTime();
    time += 3600 * 1000;
    now.setTime(time);
    document.cookie = `busUTM=${busUTM}; expires=${now.toUTCString()}; path=/`;
  }
};

export const handleUTMParams = () => {
  const { utm_source, utm_campaign, utm_medium, utm_term } = getSearchParams();
  setUTMCookie({
    ...(utm_source && { utm_source }),
    ...(utm_campaign && { utm_campaign }),
    ...(utm_medium && { utm_medium }),
    ...(utm_term && { utm_term }),
  });
};

export const getUTMData = () => {
  const UTMFromCookie =
    (getCookie("busUTM") && JSON.parse(getCookie("busUTM"))) || {};

  return UTMFromCookie;
};

export const normalizeSize = (size: number | string) => {
  if (typeof size === "number") return `${size}px`;
  return size;
};

export const downloadPdfWithBlobCode = (
  blobData: Blob | MediaSource,
  pdfName: string
) => {
  const file = window.URL.createObjectURL(blobData);
  const a = document.createElement("a");
  a.href = file;
  a.download = pdfName;
  document.body.appendChild(a);
  a.click();
  window.onfocus = function () {
    document.body.removeChild(a);
  };
};
